var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center align-middle",style:(_vm.header.length == 2 ? 'min-width: 80px' :
          _vm.header.length == 3 ? 'min-width: 100px' :
          _vm.header.length == 4 ? 'min-width: 105px' :
          'min-width: 80px'),on:{"click":function($event){return _vm.$emit('sort')}}},[_vm._v(" "+_vm._s(_vm.header)+" "),_c('i',{staticClass:"fa fa-sort",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }